import {BASE_URL} from "@/utils/config";

const URL = BASE_URL;

export const generateOtp = async (axiosInstance, verifier, verificationType, route) => {
	try {
		const {data} = await axiosInstance.post(
			`${URL}/auth/send-otp`,
			{
				verifier,
				verificationType,
				route
			},
			{
				headers: {
					"Content-Type": "application/json",
				},
			}
		);

		return data;
	} catch (error) {
		console.log("(userOtpApi.js) Error in generateOtp: ", error.response);
		return Promise.reject(error.response);
	}
}

export const matchOtp = async (axiosInstance, userId, otp, route) => {
	try {
		const {data} = await axiosInstance.post(
			`${URL}/auth/match-otp`,
			{
				userId,
				otp,
				route
			},
			{
				headers: {
					"Content-Type": "application/json",
				},
			}
		);

		return data;
	} catch (error) {
		console.log("(userOtpApi.js) Error in matchOtp: ", error);
		return Promise.reject(error.response);
	}
}
